import BaseServerInteractionService from './BaseServerInteractionService';
import {
  ORGANISATIONS_ME_INVITE_ENDPOINT,
  ORGANISATIONS_ME_ENDPOINT,
  ORGANISATIONS_ME_USERS_ENDPOINT,
} from './endpointsConstants';
import { OrganisationManageableRole } from '../../types/auth/role';
import {
  CreateOrganisationInviteRequest,
  CreateOrganisationInviteResponse,
} from '../../types/auth/invite';
import { OrganisationResponse } from '../../types/organisations/organisation';
import { UserSummaryResponse } from '../../types/organisations/userSummary';
import { parseApiCollection, parseApiJson } from './apiDataUtils';

const getCurrentOrganisation = async (): Promise<OrganisationResponse | null> => {
  const response = await BaseServerInteractionService.Get<OrganisationResponse | string>(
    `/${ORGANISATIONS_ME_ENDPOINT}`,
  );

  return parseApiJson<OrganisationResponse>(response);
};

const getOrganisationUsers = async (): Promise<UserSummaryResponse[]> => {
  const response = await BaseServerInteractionService.Get<UserSummaryResponse[] | string>(
    `/${ORGANISATIONS_ME_USERS_ENDPOINT}`,
  );

  return parseApiCollection<UserSummaryResponse>(response);
};

const createOrganisationInvite = async (
  inviteData: CreateOrganisationInviteRequest,
): Promise<CreateOrganisationInviteResponse | null> => {
  const response = await BaseServerInteractionService.Post<CreateOrganisationInviteResponse | string>(
    `/${ORGANISATIONS_ME_INVITE_ENDPOINT}`,
    inviteData,
  );

  return parseApiJson<CreateOrganisationInviteResponse>(response);
};

const updateOrganisationUserRole = async (
  userId: number,
  role: OrganisationManageableRole,
): Promise<UserSummaryResponse | null> => {
  const response = await BaseServerInteractionService.Put<UserSummaryResponse | string>(
    `/${ORGANISATIONS_ME_USERS_ENDPOINT}/${userId}/role?role=${role}`,
    {},
  );

  return parseApiJson<UserSummaryResponse>(response);
};

const deleteOrganisationUser = async (userId: number) => {
  return BaseServerInteractionService.Delete(`/${ORGANISATIONS_ME_USERS_ENDPOINT}/${userId}`, {});
};

export const organisationService = {
  getCurrentOrganisation,
  getOrganisationUsers,
  createOrganisationInvite,
  updateOrganisationUserRole,
  deleteOrganisationUser,
};
